import { StyleSheet } from 'react-native';

const ResourceBookButtonImage = ({ style }) => {
  const oneX = require('./resource-book-button.jpg');
  const twoX = require('./resource-book-button@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={StyleSheet.flatten(style)}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { ResourceBookButtonImage };
